import React, { useState } from 'react';
import Text from '../../../../Components/Base/Text/Text';
import PatientManualRegistrationButton from '../../../EArchive/Components/PatientManualRegistration/PatientManualRegistrationButton';
// @ts-ignore
import styles from './CentralEvidence.module.scss';
import CentralEvidenceSearchField from '../CentralEvidenceSearchField/CentralEvidenceSearchField';
import TreatmentModal from '../../../../Components/Treatment/TreatmentModal';
import Modal from '../../../../Components/Modal/Modal';
import PatientManualRegistrationMOU, {
	MouNumber,
} from '../../../EArchive/Components/PatientManualRegistration/Czech/MOU/PatientManualRegistrationMOU';
import CentralEvidenceVirtualProfileSelectionModal from '../CentralEvidenceVirtualProfileSelection/CentralEvidenceVirtualProfileSelectionModal';
import { useLazyRootWorkplacesPatientQuery } from '../../../../graphql/graphql';
import { useAppContext } from '../../../../Services/AppContext';
import { useEffectAsync } from '../../../../helpers';
import { WorkplacePatient } from '../CentralEvidenceVirtualProfileSelection/CentralEvidenceVirtualProfileSelection';
import useScope from '../../../Scope/Hooks/useScope';

const CentralEvidence: React.FC = () => {
	const [originalId, setOriginalId] = useState<string | undefined>();
	const [patientId, setPatientId] = useState<string | undefined>();
	const [number, setNumber] = useState<MouNumber | undefined>();
	const [patientWorkplaces, setPatientWorkplaces] = useState<
		WorkplacePatient[] | undefined
	>(undefined);
	const [isLoading, setIsLoading] = useState(false);
	const [getRootWorkplacesPatient] = useLazyRootWorkplacesPatientQuery();
	const { workplaceId } = useAppContext();
	const { isKDARWorkplace } = useScope();

	useEffectAsync(async () => {
		setIsLoading(true);
		const temp = await getRootWorkplacesPatient({
			originalId: originalId,
			workplaceId: workplaceId,
		});
		const workplaces = temp?.data?.rootWorkplacesPatient?.data;
		if (workplaces) {
			let openList = true;
			workplaces.forEach(item => {
				if (item?.user?.id && item?.workplace?.id === workplaceId) {
					openList = false;
					onVirtualSelect(item.user.id, workplaceId);
					return;
				}
			});
			if (openList) {
				setPatientWorkplaces(
					temp?.data?.rootWorkplacesPatient?.data as WorkplacePatient[],
				);
			}
		}
		setIsLoading(false);
	}, [originalId]);

	const handleSelect = (value: { id: string; number?: string }) => {
		if (value?.number) {
			setNumber({ id: value?.id, number: value?.number });
		} else {
			setOriginalId(value?.id);
		}
	};

	const onVirtualSelect = (patientId: string, desiredWorkplaceId: string) => {
		if (workplaceId !== desiredWorkplaceId) {
			// @ts-ignore
			window.location.href = `/profil-pacienta/${patientId}?workplaceId=${desiredWorkplaceId}`;
			return;
		}
		setPatientId(patientId);
		setPatientWorkplaces(undefined);
		setOriginalId(undefined);
	};

	const closeSelectionModal = () => {
		setPatientWorkplaces(undefined);
		setOriginalId(undefined);
	};

	return (
		<div className={styles.wrapper}>
			<Text
				tx='component.centralrecords.title'
				firstUpper
				className={styles.title}
			/>
			<div className={styles.content}>
				<Text
					tx='component.centralrecords.registerPatient'
					firstUpper
					className={styles.subtitle}
				/>
				<Text
					tx={
						isKDARWorkplace
							? 'component.centralrecords.iWantToRegisterNewPatientKDAR'
							: 'component.centralrecords.iWantToRegisterNewPatient'
					}
					className={styles.text}
					firstUpper
				/>
				<PatientManualRegistrationButton buttonClassName={styles.button} />
				<Text
					tx='base.shared.searchPatient'
					firstUpper
					className={styles.subtitle}
				/>
				<Text
					tx={
						isKDARWorkplace
							? 'component.centralPatientRecords.text2KDAR'
							: 'component.centralPatientRecords.text2'
					}
					className={styles.text}
				/>
				<Text
					tx={
						isKDARWorkplace
							? 'component.centralPatientRecords.text1KDAR'
							: 'component.centralPatientRecords.text1'
					}
					className={styles.text}
				/>
				<CentralEvidenceSearchField onSelect={handleSelect} />
				{patientWorkplaces && originalId && (
					<CentralEvidenceVirtualProfileSelectionModal
						onClose={closeSelectionModal}
						onSelect={onVirtualSelect}
						patientWorkplaces={patientWorkplaces}
						originalId={originalId}
						isOpen
					/>
				)}
				{patientId && (
					<TreatmentModal
						opened
						patientId={patientId}
						onClose={() => setPatientId(undefined)}
					/>
				)}
				{number && (
					<Modal opened onClose={() => setNumber(undefined)}>
						<Modal.Header title='base.registerThePatient' />
						<Modal.Content>
							<PatientManualRegistrationMOU
								onSuccess={() => setNumber(undefined)}
								number={number}
							/>
						</Modal.Content>
					</Modal>
				)}
			</div>
		</div>
	);
};

export default CentralEvidence;
